<form #organizationForm="ngForm" class="row">
	<mat-form-field class="col">
		<mat-label>{{ label }}</mat-label>
		<input matInput aria-label="Organization" type="text" [placeholder]="placeholder" [id]="id" [name]="name"
			[matAutocomplete]="auto" [(ngModel)]="localOrganization.NAME" #searchString="ngModel" #searchStringInput
			[value]="localOrganization.NAME" [required]="required" (ngModelChange)="checkForId(searchString)"
			[disabled]="disabled" />
		<button mat-icon-button matSuffix [attr.aria-label]="'City Valid'"
			[color]="selectedOrganization && selectedOrganization.ID ? 'primary' : 'warn'" tabindex="-1">
			<mat-icon mat-icon-button *ngIf="isLoading">
				<mat-spinner diameter="18"></mat-spinner>
			</mat-icon>
			<mat-icon mat-icon-button
				*ngIf="!isLoading && organizationForm.dirty && (required ? required : localOrganization && localOrganization.NAME && localOrganization.NAME.length > 0)">
				{{ selectedOrganization && selectedOrganization.ID ? "done" : "close" }}
			</mat-icon>
		</button>
		<mat-hint *ngIf="hint && hint.length > 0">{{hint}}</mat-hint>
	</mat-form-field>
	<app-msg *ngIf="!isLoading" [class.msg-up-closer]="!hint || hint.length === 0"
		[msg]="{MSG:searchString.errors?.['idRequired'], SUCCESS:!searchString.errors?.['idRequired']}"></app-msg>

	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
		<ng-container *ngIf="!isLoading">
			<mat-option *ngFor="let organization of organizations" [value]="organization">
				{{organization.NAME}}
			</mat-option>
		</ng-container>
	</mat-autocomplete>
</form>